module.exports = __webpack_public_path__ + "static/media/checked-icon.8c55fce1.svg";